import * as React from "react";
import { cn } from "@/lib/utils";
import { Button } from "./button";

interface BatchFilterPillsProps {
  value: "all" | "5-8 years" | "8+ years";
  onChange: (value: "all" | "5-8 years" | "8+ years") => void;
  className?: string;
  testId?: string;
}

export function BatchFilterPills({
  value,
  onChange,
  className,
  testId,
}: BatchFilterPillsProps) {
  const options: Array<{ value: "all" | "5-8 years" | "8+ years"; label: string }> = [
    { value: "all", label: "All Batches" },
    { value: "5-8 years", label: "5-8 Years" },
    { value: "8+ years", label: "8+ Years" },
  ];

  return (
    <div className={cn("flex items-center gap-2 flex-wrap", className)} data-testid={testId}>
      {options.map((option) => (
        <Button
          key={option.value}
          variant={value === option.value ? "default" : "outline"}
          size="sm"
          onClick={() => onChange(option.value)}
          data-testid={`filter-age-group-${option.value}`}
        >
          {option.label}
        </Button>
      ))}
    </div>
  );
}
